module.exports = __webpack_public_path__ + "static/media/DamagedWindowBrand.701558c0.jpg";